import React from 'react';

import { deploymentEnvLabel } from './promotionsUtils';

interface PromotionEnvBadgeProps {
  /** A deployment sub-domain (e.g. `staging`, `us`). The backend blanks the value for same-DB / upload
   * pairings, so an empty string / null / undefined renders nothing — presence of a value is the single
   * cross-deployment signal. */
  subDomain?: string | null;
}

/** The one place a config-promotion environment is rendered: a subtle chip showing the friendly label (from
 * {@link deploymentEnvLabel}) for a deployment sub-domain. Shared by the outgoing/incoming tables, the detail
 * dialogs, and the create dialog's target dropdown so every env render site looks identical. */
const PromotionEnvBadge: React.FC<PromotionEnvBadgeProps> = ({ subDomain }) => {
  if (!subDomain) {
    return null;
  }
  return <span className="rounded bg-slate-100 px-8 py-2 text-sm text-slate-700">{deploymentEnvLabel(subDomain)}</span>;
};

export default PromotionEnvBadge;
